import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useExportBookingsAsXlsDialogFormValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  const schema = z
    .object({
      from: z.date(),
      to: z.date(),
    })
    .refine(
      values => {
        return values.from < values.to;
      },
      {
        message: t('validation:endDateMustBeGreater'),
        path: ['to'],
      },
    );

  return schema;
};
